<div class="row">
  <div class="col-lg-4">

    <div class="container-fluid pl-0 info-list">

      <ng-container *ngIf="isFreemium || data?.regionDistribution?.length > 0">
        <div class="d-flex info-list-item top-distribution-list">
          <div class="label">
            Top Region
          </div>
          <div class="value">
            <div class="top-item-label">{{topRegion?.countryCode === 'NA' ? 'North America' : topRegion?.countryCode}}
            </div>
            <div class="big-number" enAnonLock>{{topRegion?.totalInventoryRatio | perc: '1.2-2'}}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isFreemium || data?.adSizeDistribution?.length > 0">
        <div class="divider mt-32px mb-24px"></div>
        <div class="d-flex info-list-item top-distribution-list">
          <div class="label">
            Top Ad Size
          </div>
          <div class="value">
            <div class="top-item-label">{{topAdSize?.adSize}}</div>
            <div class="big-number" enAnonLock>{{topAdSize?.totalInventoryRatio | perc: '1.2-2'}}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isFreemium || data?.dmaDistribution?.length > 0">
        <div class="divider mt-32px mb-24px"></div>
        <div class="d-flex info-list-item top-distribution-list">
          <div class="label">
            Top DMA
          </div>
          <div class="value">
            <div class="top-item-label">{{topDma?.dmaName}}</div>
            <div class="big-number" enAnonLock>{{topDma?.totalInventoryRatio | perc: '1.2-2'}}</div>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
  <div class="col-lg-8">
    <div class="container-fluid pl-0 info-list has-info-icon">
      <ng-container *ngIf="isFreemium || data?.regionDistribution?.length > 0">
        <h3 class="sub-title">
          <img src="/assets/images/icon-region.svg" alt="Region Icon" />
          Inventory by Region
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of programmatic ad impressions broken down by business region.">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="regionHeaders" [currentSort]="'totalInventoryRatio'"
          [data]="data?.regionDistribution" [limit]="showMoreLimit"
          (itemClick)="goTo($event)"></app-data-table-component>
      </ng-container>

      <ng-container *ngIf="data?.adSizeDistribution?.length > 0">
        <h3 class="sub-title mt-32px">
          <img src="/assets/images/icon-ad-sizes.svg" alt="AdSize Icon" />
          Inventory by Ad Size
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of programmatic ad impressions broken down by ad size.">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="adSizeHeaders" [currentSort]="'totalInventoryRatio'"
          [data]="data?.adSizeDistribution" [limit]="showMoreLimit"
          (itemClick)="goTo($event)"></app-data-table-component>
      </ng-container>

      <ng-container *ngIf="data?.dmaDistribution?.length > 0">
        <h3 class="sub-title mt-32px">
          <img src="/assets/images/icon-market-area.svg" alt="Market Area Icon" />
          Inventory by DMA
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of programmatic ad impressions broken down by Designated Market Area (DMA).">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="dmaHeaders" [currentSort]="'totalInventoryRatio'"
          [data]="data?.dmaDistribution" [limit]="showMoreLimit" (itemClick)="goTo($event)"></app-data-table-component>
      </ng-container>

      <ng-container *ngIf="data?.user?.byMonth">
        <h3 class="sub-title mt-32px">
          <img src="/assets/images/icon-users-grey.svg" alt="User Icon" />
          Inventory by Users
        </h3>
        <app-line-chart [data]="lineChartData" [valueFields]="['dailyActiveUsers','monthlyActiveUsers']"
          [categoryField]="'month'" [titleArray]="['Est. Daily Reach', 'Est. Monthly Reach']" [height]="'500px'"
          [type]="'double'"></app-line-chart>
      </ng-container>
    </div>
  </div>
</div>